import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import LoaderComponent from '@components/LoaderComponent';
import { toastError } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const DownloadStickerFabric = ({ selectedMaterials, materialDataList, object, count, onclose }) => {
	const [show] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [itemList, setItemList] = useState(materialDataList);
	const [firstTimeCheckQty, setFirstTimeCheckQty] = useState(true);
	const [firstTimeCheckDate, setFirstTimeCheckDate] = useState(true);
	const [firstTimeCheckBuyer, setFirstTimeCheckBuyer] = useState(true);
	const [firstTimeCheckToggle, setFirstTimeCheckToggle] = useState(true);

	const handleClose = () => {
		onclose();
	};

	const onValChange = (event, key, item, isFirstTime) => {
		event.preventDefault();

		let modifyList = itemList.map((obj) => {
			if (!isFirstTime && obj.materialId === item.materialId) {
				obj[key] = event.target.value;
			}
			if (isFirstTime) {
				obj[key] = event.target.value;
			}
			return obj;
		});
		setItemList(modifyList);
	};
	const onToggle = (isToggle, item, isFirstTime, setFirstTime) => {
		let modifyList = itemList.map((obj) => {
			if (!isFirstTime && obj.materialId === item.materialId) {
				obj.toggle = !isToggle;
			}
			if (isFirstTime) {
				obj.toggle = !isToggle;
			}
			return obj;
		});
		setFirstTime(false);
		setItemList(modifyList);
	};

	const onDownloadSticker = () => {
		setIsLoading(true);
		let requestObject = {};
		if (object !== null) {
			requestObject = object;
		} else {
			requestObject.materialIdList = selectedMaterials;
		}
		if (itemList.length > 0) {
			requestObject.stickerMaterialOtherInfos = itemList;
		}
		let url = 'downloadMaterialStickers';

		ApiClient.POST(url, requestObject)
			.then((response) => {
				window.open(response.data, '_parent');
				setIsLoading(false);
			})
			.catch(({ response }) => {
				setIsLoading(false);
				toastError(response.data.message);
			});
	};

	return (
		<LoaderComponent loading={isLoading}>
			<Modal
				show={show}
				onHide={handleClose}
				backdrop="static"
				centered
				className="sticker-download-modal"
			>
				<div className="common-popup sticker-download-modal">
					<Modal.Header closeButton>
						<Modal.Title className="semibold-16 mb-0"> Download sticker</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="common-popup-body pb-0">
							<table className="table with-border">
								<thead>
									<tr>
										<th>Fabric({count})</th>
										<th>Sticker qty</th>
										<th>Date</th>
										<th>Buyer</th>
										<th>Supplier name</th>
									</tr>
								</thead>
								<tbody>
									{itemList?.map((item, index) => {
										return (
											<tr key={`sticker_item_${index}`}>
												<td>
													<div className="d-flex align-items-center">
														{item?.docUrl && (
															<img src={item.docUrl} alt="fabric" />
														)}
														{!item?.docUrl && (
															<img
																src={`${process.env.PUBLIC_URL}/images/fabric-default.png`}
																alt="fabric"
															/>
														)}
														<div className="ml-12">
															<p className="regular-12 gray_dark_01 mb-1">
																{item.referenceNumber}
															</p>
															<ul className="common-list-component">
																<li className="text-uppercase gray_dark_02">
																	{item.supplierName}
																</li>
																<li className="text-uppercase gray_dark_02">
																	{item.supplierRefNumber}
																</li>
															</ul>
														</div>
													</div>
												</td>
												<td>
													<input
														type="number"
														name={'stickerQuantity' + index}
														id={'quanitiy' + index}
														value={item.stickerQuantity}
														onBlur={() => setFirstTimeCheckQty(false)}
														onChange={(e) =>
															onValChange(
																e,
																'stickerQuantity',
																item,
																firstTimeCheckQty
															)
														}
													/>
												</td>
												<td>
													<input
														type="text"
														autoComplete="off"
														placeholder="DD MMM, YY"
														name={'date' + index}
														id={'date' + index}
														value={item.date}
														onBlur={() => setFirstTimeCheckDate(false)}
														onChange={(e) =>
															onValChange(e, 'date', item, firstTimeCheckDate)
														}
													/>
												</td>
												<td>
													<input
														type="text"
														autoComplete="off"
														name={'buyerName' + index}
														id={'buyerName' + index}
														value={item.buyerName}
														onBlur={() => setFirstTimeCheckBuyer(false)}
														onChange={(e) =>
															onValChange(
																e,
																'buyerName',
																item,
																firstTimeCheckBuyer
															)
														}
													/>
												</td>
												<td>
													<img
														src={
															item.toggle
																? `${process.env.PUBLIC_URL}/icons/toggle-on.svg`
																: `${process.env.PUBLIC_URL}/icons/toggle-off.svg`
														}
														alt="toggle"
														name={'toggle' + index}
														id={'toggle' + index}
														onClick={() =>
															onToggle(
																item.toggle,
																item,
																firstTimeCheckToggle,
																setFirstTimeCheckToggle
															)
														}
													/>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div className="footer-buttons text-right">
							<button className="button outline size32" onClick={() => handleClose()}>
								Cancel
							</button>
							<button
								disabled={isLoading}
								className="button size32 ml-2"
								onClick={() => onDownloadSticker()}
							>
								Downloads
							</button>
						</div>
					</Modal.Footer>
				</div>
			</Modal>
		</LoaderComponent>
	);
};

export default DownloadStickerFabric;
